module.exports = __webpack_public_path__ + "img/logo-only-oliver.5e289a27.png";